// extracted by mini-css-extract-plugin
module.exports = {"thumbnailContainer":"MonoImageGallery_thumbnailContainer__NGQIs","galleryContainer":"MonoImageGallery_galleryContainer__B82Tc"};